export const isiPhone = /iPhone/i.test(navigator.userAgent);
